/**
*   Custom JS
*/

document.addEventListener('DOMContentLoaded', () => {

    /**
    *   Subnavigation --
    */
    function subnavigationToggle() {
        let buttons = document.querySelectorAll('.js-subnavigation-toggle');

        if (!buttons) return;

        buttons.forEach(button => {
            let subnavigation = button.parentElement.parentElement;

            button.addEventListener('click', function () {
                subnavigation.classList.toggle('subnavigation--open');
            });
        });
    }


    /**
    *   Featured Applications
    */
    function applicationLinkHover() {
        let containers = document.querySelectorAll('.js-featured-applications');

        if (!containers) return;

        containers.forEach(container => {
            let cards            = container.querySelectorAll('.collection-list__item');
            let previewContainer = container.querySelector('.js-featured-applications-preview');

            cards.forEach(card => {
                let image   = card.querySelector('.card__media img');

                card.addEventListener('mouseover', function () {
                    previewContainer.innerHTML = '';
                    previewContainer.appendChild(document.createElement('img')).srcset = image.srcset;
                });

                card.addEventListener('mouseout', function () {
                    previewContainer.innerHTML = '';
                    previewContainer.appendChild(document.createElement('img')).srcset = image.srcset;
                });
            });


        });

    }


    /**
    *   Fifty Fifty Height Toggles
    */
    function contentAccordions() {
        const toggles = document.querySelectorAll('.js-artek-fifty-toggle');

        if (!toggles) return;

        toggles.forEach(toggle => {
            let parent          = toggle.closest('.artek-fifty');
            let subcontentInner = toggle.parentElement.querySelector('.artek-fifty__subcontent-inner');
            let maxHeight       = 30;

            if (subcontentInner.childNodes) {
                subcontentInner.childNodes.forEach(c => { if (c.offsetHeight) maxHeight += c.offsetHeight });
            }

            toggle.onclick = () => {
                if (parent.classList.contains('artek-fifty--collapsed')) {
                    parent.classList.replace('artek-fifty--collapsed', 'artek-fifty--expanded')
                    subcontentInner.style.maxHeight = `${maxHeight}px`;

                    toggle.innerHTML = '-';

                } else {
                    parent.classList.replace('artek-fifty--expanded', 'artek-fifty--collapsed')
                    subcontentInner.style.maxHeight = '80px';
                    toggle.innerHTML = '+';
                }
            }
        });
    }

    /**
    *   FAQ Accordion
    */
    function faqAccordions() {
        const accordions = document.querySelectorAll('.js-faqs-list-item');

        if (!accordions) return;

        const openAccordion = (accordion) => {
            let content = accordion.querySelector('.faqs-list-item__content');

            accordion.classList.add('faqs-list-item--expanded');
            content.style.maxHeight = content.scrollHeight + 'px';
        }

        const closeAccordion = (accordion) => {
            let content = accordion.querySelector('.faqs-list-item__content');

            accordion.classList.remove('faqs-list-item--expanded');
            content.style.maxHeight = null;
        }

        accordions.forEach(accordion => {
            let toggle = accordion.querySelector('.faqs-list-item__title');
            let content = accordion.querySelector('.faqs-list-item__content');

            toggle.onclick = () => {
                if (content.style.maxHeight) {
                    closeAccordion(accordion);
                } else {
                    accordions.forEach((accordion) => closeAccordion(accordion));
                    openAccordion(accordion);
                }
            }
        });
    }


    // Trigger these functions when the DOM loads
    (function initializeOnLoad() {
        subnavigationToggle();
        applicationLinkHover();
        contentAccordions();
        faqAccordions();
    })();
});
